module.exports = __webpack_public_path__ + "img/Allec-New-Logo-I.94c9a0cb.png";